<template>
  <v-layout column class="conditions">
    <div v-if="loading" class="text-center ma-3">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-card v-else-if="valid === false" id="assessment-error" flat light class="assessment-error pa-4 text-center">
      <v-icon size="48" class="assessment-error__icon mb-2">
        {{ connectionLost ? icons.mdiCloudOffOutline : icons.mdiAlertCircleOutline }}
      </v-icon>
      <h2 class="assessment-error__title mb-2">
        {{ connectionLost
          ? $t('app.assessment_mode.text.network_error.title')
          : $t('app.device.list.location_check.error') }}
      </h2>
      <p class="assessment-error__message">
        {{ connectionLost
          ? $t('app.assessment_mode.guided.network_error.message')
          : $t('app.assessment_mode.assessment_error.message') }}
      </p>
      <p v-if="notify" class="assessment-error__message">
        <mrx-translation :token="message"></mrx-translation>
      </p>
      <button id="retry-assessment" type="button" class="assessment-error__retry mt-2" @click="retry">
        {{ $t('app.assessment_mode.text.network_error.retry') }}
      </button>
    </v-card>
    <template v-else>
      <PreTriageDialog
          :value="showPreTriageDialog"
          :triage="overallTriage"
          @acknowledge="acknowledgeTriage"
      />
      <MrxTriage instructions />
      <risk-assessment-item
          v-for="section in triageSections"
          :key="section.triage"
          :isChecklist="true"
          :headerToken="section.headerToken"
          :headerIconColor="section.headerIconColor"
          :contentList="section.contentList"
          :disabledItems="section.disabledItems"
          :isCollapsible="true"
          :initiallyCollapsed="section.initiallyCollapsed"
          v-model="selected"
          @handleInput="setSelected"
      />
    </template>
  </v-layout>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import MrxTriage from "@/components/thinkmd/mrx/triage.vue";
import RiskAssessmentItem from "./RiskAssessmentItem.vue";
import PreTriageDialog from "./PreTriageDialog.vue";
import languageLogic from "@/mixins/languageLogic";
import mrx from "@/mixins/mrx";
import icons from "@/mixins/icons";
import { useRiskAssessmentWorkflow } from "../../composables/useRiskAssessmentWorkflow";

export default defineComponent({
  name: 'OverallRiskAssessment',
  components: { MrxTriage, RiskAssessmentItem, PreTriageDialog },
  mixins: [languageLogic, mrx, icons],
  setup() {
    return useRiskAssessmentWorkflow();
  },
  async beforeRouteLeave(to, from, next) {
    this.handleBeforeRouteLeave(to, from, next);
  },
})
</script>
